const Year5 = [
    {id: "12", value: "1年"},    
    {id: "24", value: "2年"},
    {id: "36", value: "3年"},
    {id: "48", value: "4年"},
    {id: "60", value: "5年"}
  ];  
  
  export default Year5  